import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Api from "api/Api";
import { useNavigate } from "react-router-dom";
import { resetBoards } from "store/boardsSlice";
import { selectCompanyInfo } from "store/companySlice";
import { closeModal } from "store/modalsSlice";

import Button from "layout/atoms/Button";
import ContentBox from "layout/atoms/ContentBox";
import Form from "layout/atoms/Form";
import InputText from "layout/atoms/InputText";
import Modal from "layout/atoms/Modal";

const AddBoardModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const api = new Api();
  const companyInfo = useSelector(selectCompanyInfo);
  const { t } = useTranslation("translation", { keyPrefix: "createNewBoard" });
  const {
    register,
    handleSubmit,
    formState,
    formState: { errors, isSubmitSuccessful },
    reset,
  } = useForm({ defaultValues: { title: "", description: "" } });

  const handleClose = () => dispatch(closeModal("addBoardModal"));

  const createBoard = async (data) => {
    const companyId = companyInfo.id;
    await api
      .createNewBoard(data, companyId)
      .then((response) => {
        dispatch(resetBoards());
        handleClose();
        navigate(`/admin/boards/${response.id}/list`);
      })
      .catch(() => console.log("Error toast"));
  };

  useEffect(() => {
    if (formState.isSubmitSuccessful) reset();
  }, [formState, isSubmitSuccessful, reset]);

  return (
    <Modal open onClose={handleClose}>
      <Form onSubmit={handleSubmit(createBoard)}>
        <ContentBox
          icon="plus-square"
          header={<h3>{t("title")}</h3>}
          footer={
            <>
              <div />
              <div>
                <Button
                  size="lg"
                  color="white"
                  onClick={() => {
                    reset();
                    handleClose();
                  }}
                >
                  {t("form.buttons.cancel")}
                </Button>
                <Button type="submit" size="lg" color="primary">
                  {t("form.buttons.create")}
                </Button>
              </div>
            </>
          }
        >
          <InputText
            type="text"
            name="name"
            label={t("form.fields.name.label")}
            placeholder={t("form.fields.name.placeholder")}
            register={register}
            errors={errors.email}
            validation={{ required: true, minLength: 6, maxLength: 50 }}
          />
        </ContentBox>
      </Form>
    </Modal>
  );
};

export default AddBoardModal;
